import React from 'react';
import loaderVideo from '../../assets/loading/loader.mp4';

function LoadingScreen({ onEnded }) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <video
        src={loaderVideo}
        autoPlay
        muted
        playsInline
        onEnded={onEnded}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
        }}
      />
    </div>
  );
}

export default LoadingScreen;

